import { queryOptions } from '@tanstack/react-query';
import { getAgentById } from './agents.api';
import { queryClient } from '@/lib/config';
import { getActiveWorkspaceId } from '@/lib/workspace-context/workspace-context-bindings';

/** Workspace segment keeps overrides (name/description) correct per context and avoids stale labels after admin rename. */
export const agentQueryOptions = (agentId: string, workspaceId?: string | null) =>
  queryOptions({
    queryKey: ['agent', agentId, workspaceId ?? ''],
    queryFn: () => getAgentById(agentId),
    staleTime: 5 * 60 * 1000,
  });

export function fetchAgent(agentId: string) {
  const workspaceId = getActiveWorkspaceId();
  return queryClient.fetchQuery(agentQueryOptions(agentId, workspaceId));
}
